module.exports = __webpack_public_path__ + "img/24600.f0b35021.jpg";